// extracted by mini-css-extract-plugin
module.exports = {"text":"styles_text__H_1IU"};